import React from 'react';
import { Card, CardContent, Typography, Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import logo from '../assets/skill-exchange-logo.png';

export default function HomePage() {
  return (
    <Box sx={{ maxWidth: { xs: '100%', sm: 400, md: 700 }, margin: { xs: '16px 0', sm: '40px auto' }, p: { xs: 1, sm: 2 } }}>
      <Card sx={{ borderRadius: 3, boxShadow: 3, width: { xs: '100%', sm: 'auto' } }}>
        <CardContent sx={{ px: { xs: 1, sm: 3 }, py: { xs: 2, sm: 3 } }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <img src={logo} alt="Skill Exchange Logo" style={{ height: 60, maxWidth: '90vw', borderRadius: 16 }} aria-label="Skill Exchange App Logo" />
          </Box>
          <Typography variant="h4" align="center" gutterBottom>
            Welcome to Skill Exchange App
          </Typography>
          <Typography variant="h6" align="center" color="primary" gutterBottom>
            Learn. Share. Grow. Together.
          </Typography>
          <Typography variant="subtitle1" align="center" sx={{ mt: 3, mb: 2, color: 'text.secondary' }}>
            <b>Top Skills Registered on Our Platform:</b>
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 3, lineHeight: 1.6 }}>
            Python, Generative AI, JavaScript, Data Science, UI/UX Design, Public Speaking, French, Hindi, React, Node.js, Cooking, Yoga, Photography, Music, Tabla, Machine Learning, Deep Learning
          </Typography>
          <Typography variant="body1" sx={{ mt: 2, mb: 3, lineHeight: 1.7 }}>
            <b>Skill Exchange App</b> is a platform that connects people who want to learn new skills with those who are eager to share their expertise. Whether you want to teach, learn, or both, this app makes it easy to find the right partners and schedule sessions that fit your availability.
          </Typography>
          <Typography variant="subtitle1" sx={{ mb: 1 }}><b>Key Benefits:</b></Typography>
          <List>
            <ListItem>
              <ListItemIcon><PeopleAltIcon color="success" /></ListItemIcon>
              <ListItemText primary="Discover learning partners and mentors from diverse backgrounds." />
            </ListItem>
            <ListItem>
              <ListItemIcon><SwapHorizIcon color="primary" /></ListItemIcon>
              <ListItemText primary="Exchange skills: Offer what you know, learn what you want." />
            </ListItem>
            <ListItem>
              <ListItemIcon><AccessTimeIcon color="secondary" /></ListItemIcon>
              <ListItemText primary="Flexible scheduling: Set your availability and connect at convenient times." />
            </ListItem>
            <ListItem>
              <ListItemIcon><EmojiObjectsIcon color="warning" /></ListItemIcon>
              <ListItemText primary="Grow your network and gain new perspectives while helping others." />
            </ListItem>
          </List>
          <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
            Ready to get started? Use the menu to set up your profile, list your interests, and find your ideal learning partner!
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
